var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.noSiteId)?_c('no-site'):[(_vm.fetchingSites)?_c('page-loader'):[(_vm.sites.length < 1)?_c('no-site'):(_vm.loading)?_c('page-loader'):[_vm._t("default")]]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }